/**
 * i18n configuration using react-i18next
 *
 * Supports English and Japanese at launch.
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../locales/en.json';
import ja from '../locales/ja.json';

// Detect browser language preference
function detectLanguage(): string {
  // Check localStorage first
  const stored = localStorage.getItem('language');
  if (stored && (stored === 'en' || stored === 'ja')) {
    return stored;
  }

  // Check browser language
  const browserLang = navigator.language.split('-')[0];
  if (browserLang === 'ja') {
    return 'ja';
  }

  return 'en';
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ja: { translation: ja },
  },
  lng: detectLanguage(),
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // React already escapes values
  },
  react: {
    useSuspense: true,
  },
});

// Export function to change language
export function setLanguage(lang: 'en' | 'ja'): void {
  localStorage.setItem('language', lang);
  i18n.changeLanguage(lang);
  document.documentElement.lang = lang;
}

// Export function to get current language
export function getLanguage(): 'en' | 'ja' {
  return i18n.language as 'en' | 'ja';
}

export default i18n;
